module.exports = __webpack_public_path__ + "static/media/mascot.a32c73f7.png";